import HowSessionsWorkSection from "./components/HowSessionsWorkSection";
import InstructorSection from "./components/InstructorSection";
import JoinUsSection from "./components/JoinUsSection";
import RevisionHeroSection from "./components/RevisionHeroSection";
import WhatWeCoverSection from "./components/WhatWeCoverSection";
import WhyDoingThisSection from "./components/WhyDoingThisSection";
import WhySkillsFadeSection from "./components/WhySkillsFadeSection";

const RevisionLandingPage = () => {
    return (
        <>
            <RevisionHeroSection />
            <InstructorSection />
            <WhyDoingThisSection />
            <HowSessionsWorkSection />
            <WhySkillsFadeSection />
            <WhatWeCoverSection />
            <JoinUsSection sessionTitle={{ heading: "revision-class", time: "6pm" }} />
        </>
    )
}

export default RevisionLandingPage;